import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  connect() {
    this.element.addEventListener("turbo:submit-end", (event) => {
      const { detail } = event;

      if (detail.success) {
        this.openModal();
      }
    });
  }

  openModal() {
    this.modalTarget.classList.remove("hidden");
  }
}
